module.exports = __webpack_public_path__ + "img/new_index_industry_icon6.b37b98bd.png";